import React from 'react';
import PropTypes from 'prop-types';
import { StandardHead } from './templates/standard/standard-head';
import { TypeaheadHead } from './templates/typeahead/typeahead-head';
import 'AppSrc/core/style/components/form/form-base-components/templated-option-button/templated-option-button-head.css';
import {
  STANDARD_DROPDOWN,
  CATEGORISED_DROPDOWN,
  CATEGORISED_TYPEAHEAD,
} from './templates/dropdown-templates';

const componentMap = {
  // some components don't have a specific head and so just use the standard one
  [STANDARD_DROPDOWN]: StandardHead,
  [CATEGORISED_DROPDOWN]: StandardHead,
  [CATEGORISED_TYPEAHEAD]: TypeaheadHead,
};


const getOptionButtonHead = (optionTemplate) => {

  const OptionButtonHead = componentMap[optionTemplate];

  if (!OptionButtonHead) {
    console.warn(`FALLING BACK TO ${STANDARD_DROPDOWN} DROPDOWN AS UNABLE TO FIND A TEMPLATE FOR ${optionTemplate}`);
    return componentMap[STANDARD_DROPDOWN];
  }

  return OptionButtonHead;
};


const TemplatedOptionButtonHead = React.memo(({
  selectedDisplayValue,
  placeholder,
  toggleOpenDropdown,
  openDropdown,
  optionTemplate,
  disabled,
  dropdownOpen,
  fieldId,
  clearValue,
}) => {

  const OptionButtonHead = getOptionButtonHead(optionTemplate);

  return (
    <OptionButtonHead
      selectedDisplayValue={selectedDisplayValue}
      placeholder={placeholder}
      toggleOpenDropdown={toggleOpenDropdown}
      openDropdown={openDropdown}
      disabled={disabled}
      dropdownOpen={dropdownOpen}
      fieldId={fieldId}
      clearValue={clearValue}
    />
  );
});

TemplatedOptionButtonHead.propTypes = {
  selectedDisplayValue: PropTypes.string,
  placeholder: PropTypes.string,
  toggleOpenDropdown: PropTypes.func,
  openDropdown: PropTypes.func,
  optionTemplate: PropTypes.oneOf([
    STANDARD_DROPDOWN,
    CATEGORISED_DROPDOWN,
    CATEGORISED_TYPEAHEAD,
  ]).isRequired,
  disabled: PropTypes.bool,
  dropdownOpen: PropTypes.bool,
  fieldId: PropTypes.string,
  clearValue: PropTypes.func,
};



export { TemplatedOptionButtonHead };
